import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { fetchCurrentTenantApi } from 'api/tenants-api';
import { elevateTheme } from 'configs/tenant.config';
import dayjs from 'dayjs';
import toast from 'react-hot-toast';
import { PURGE } from 'redux-persist';
import { getErrorString } from 'utils';

const initialState = {
  tenantData: { ...elevateTheme() },
  timeStamp: null,
  loading: true,
  domainUrl: '',
  error: null,
};

export const fetchCurrentTenant = createAsyncThunk('tenant/detail', async (domainUrl = '', thunkAPI) => {
  try {
    const res = await fetchCurrentTenantApi();
    return { res: { ...res }, domainUrl };
  } catch (error) {
    const status = error?.response?.status;
    if (status === 404) {
      return thunkAPI.rejectWithValue({ status, message: 'Tenant not found' });
    } else if (status === 500) {
      return thunkAPI.rejectWithValue({ status, message: 'Server Error' });
    }
    toast.error(getErrorString(error));
  }
});

const TenantSlice = createSlice({
  name: 'tenant',
  initialState,
  reducers: {
    setTenantData: (state, action) => {
      state.tenantData = action?.payload?.tenantData ?? state?.tenantData;
      state.timeStamp = action?.payload?.timeStamp ?? state?.timeStamp;
      state.loading = action?.payload?.loading ?? state?.loading;
      state.domainUrl = action?.payload?.domainUrl ?? state?.domainUrl;
    },
  },
  extraReducers(builder) {
    builder.addCase(fetchCurrentTenant.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(fetchCurrentTenant.fulfilled, (state, action) => {
      state.loading = false;
      state.tenantData = action.payload?.res;
      state.timeStamp = dayjs().toISOString();
      state.domainUrl = action?.payload?.domainUrl ?? state?.domainUrl;
      state.error = null;
    });
    builder.addCase(fetchCurrentTenant.rejected, (state, action) => {
      state.loading = false;
      if (action.payload?.status) {
        state.error = {
          code: action.payload?.status,
          message: action.payload?.message,
        };
      }
    });
  },
});

export const { setTenantData } = TenantSlice.actions;
export default TenantSlice.reducer;
